import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@pwc/pwc-deals-ui';
import {
  sortAscending,
  sortDescending,
} from '../../common/components/proptypes/commonProptypes';
import SortChevron from './SortChevron';

const ListHeaderCell = ({
  text,
  testId,
  sortKey,
  sortDir,
  currentSortKey,
  setCurrentSortKey,
  setCurrentSortDir,
  className,
  children,
  disabled,
}) => {
  const isCurrentSort = sortKey === currentSortKey;
  const handleClick = () => {
    let newSortDirection = sortDir;
    if (isCurrentSort) {
      newSortDirection =
        sortDir === sortAscending ? sortDescending : sortAscending;
    }

    setCurrentSortKey(sortKey);
    setCurrentSortDir(newSortDirection);
  };

  const cellClassNames = classNames('button-no-underline', 'header-cell', {
    [className]: !!className,
  });

  return (
    <Button
      className={cellClassNames}
      data-testid={testId}
      onClick={handleClick}
      disabled={disabled}
    >
      {text}
      {children}
      {isCurrentSort ? <SortChevron currentSortDir={sortDir} /> : null}
    </Button>
  );
};

ListHeaderCell.propTypes = {
  text: PropTypes.string,
  testId: PropTypes.string,
  sortKey: PropTypes.string.isRequired,
  currentSortKey: PropTypes.string.isRequired,
  setCurrentSortKey: PropTypes.func.isRequired,
  setCurrentSortDir: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

ListHeaderCell.defaultProps = {
  text: '',
  testId: '',
  className: '',
  disabled: false,
};

export default ListHeaderCell;
